/**
 * @module ChartSettingsV2
 * @description 图表设置面板入口（Phase 7 集成 — 已接入页面）
 *
 * 拓扑结构：
 *   ChartSettingsProvider（外层，Analysis/index.tsx）— useReducer 管理 base/draft/hasDraft/recalcTriggerVersion
 *     └─ ChartSettingsV2（纯渲染组件，不重复包裹 Provider）
 *        └─ ChartSettingsPanel（Shell → 遍历 Config A groups → 渲染）
 *
 * 外部消费者：
 *   ① Analysis/index.tsx — 包裹 Provider
 *   ② useColumnSortEffect — 读取 base.column_sort
 *   ③ Search — 监听 recalcTriggerVersion 触发重算
 *   ④ useChartSettingsDvaSync — 下线（Phase 9 删除）
 *
 * @see 重构后迁移方案 — 入口拓扑
 */

import React from 'react';
import ChartSettingsPanel from './ChartSettingsPanel';

/**
 * ChartSettingsV2 — 图表设置面板根组件
 *
 * 注意：Provider 由外层 Analysis/index.tsx 统一包裹，本组件不再重复创建 Provider。
 * 这样 Panel、ChartDisplay (useColumnSortEffect)、QueryBuilder (useChartsIsSubmitSignal)
 * 三者共享同一个 V2 Context 实例，确保数据一致性。
 */
const ChartSettingsV2: React.FC = () => <ChartSettingsPanel />;

ChartSettingsV2.displayName = 'ChartSettingsV2';

export default ChartSettingsV2;
